export default {
  SET_CLIENT_TYPES: function (state, payloads) {
    state.clientTypes = payloads;
  }
}
